import { AlertCrud } from "features/alert/alertCrud";
import React from "react";
import { BreadcrumbItem } from "core/components/breadcrumb";
import { BreadcrumbContainer } from "core/components/breadcrumb";
import { PageHeader } from "core/components/pageHeader";

export const AlertTableActions = () => {
  return (
    <React.Fragment>
      <div className="content-container__header">
        <PageHeader
          header={"Alerts"}
          description={"Interface for handling alerts"}
        />
        <BreadcrumbContainer>
          <BreadcrumbItem label={"Home"} />
          <BreadcrumbItem label={"Alerts"} active={true} />
        </BreadcrumbContainer>
      </div>
      {/* /.content__header */}
      <div className="content-container__body">
        <div className="dashboard">
          <div className="dashboard__tab-content">
            <AlertCrud />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
